import { ApplicationUIAction } from "state/actions/types/ui/applicationUIActionsTypes";
import { GlobalSettings } from "types";

export interface ApplicationUIReducer {
  globalSettings: GlobalSettings;
}

const initialState: ApplicationUIReducer = {
  globalSettings: {
    instagramLink: "",
    additionalReadings: [],
    termsConditions: "",
    faq: [],
    shopProducts: []
  }
};

export default (
  state: ApplicationUIReducer = initialState,
  action: ApplicationUIAction
): ApplicationUIReducer => {
  switch (action.type) {
    case "FETCH_GLOBAL_SETTINGS_FULFILLED":
      return {
        ...state,
        globalSettings: action.payload
      };
    default:
      return state;
  }
};
